import api from '../api/axiosConfig';

export const organisationApi = {
    getList: async (skip = 0, limit = 20) => {
        const response = await api.get('/organisation/list', {
            params: { skip, limit },
            silent: true
        });
        return response.data;
    },
    getById: async (org_id) => {
        const response = await api.get(`/organisation/${org_id}`, {
            silent: true
        });
        return response.data;
    },
    getDepartmentsByOrganisationId: async (org_id, skip = 0, limit = 20) => {
        const response = await api.get(`/organisation/${org_id}/departments`, {
            params: { skip, limit },
            silent: true
        });
        return response.data;
    }
};

export const departmentApi = {
    getList: async (skip = 0, limit = 20) => {
        const response = await api.get('/department/list', {
            params: { skip, limit },
            silent: true
        });
        return response.data;
    },
    getListByOrganisation: async (organisationId, skip = 0, limit = 20) => {
        const response = await api.get(`/organisation/${organisationId}/departments`, {
            params: { skip, limit },
            silent: true
        });
        return response.data;
    },
};
